import { GET_PAYMENT_INFO, GET_PAYMENT_INFO_START, GET_PAYMENT_INFO_FAILED } from "./constants";

const INITIAL_STATE = {
  customerInfo: {},
  paymentInfo: {},
};

const paymentReducer = (state = INITIAL_STATE, actions) => {
  switch (actions.type) {
    case GET_PAYMENT_INFO_START:
      return {
        ...state,
        loading: true,
      };

    case GET_PAYMENT_INFO:
      return {
        ...state,
        loading: false,
        paymentInfo: actions.payload,
      };

    case GET_PAYMENT_INFO_FAILED:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};

export default paymentReducer;
